function logMetadata(retryCount = 0) {
    const MAX_IFRAME_RETRIES = 12;
    const IFRAME_RETRY_DELAY_MS = 250;

    // Get invitation data from window.storedInvitationData or formDataStorage
    let parsedLocalData = {};
    // console.log("Log Meta data");
    
    // First try window.storedInvitationData (server-embedded)
    if (window.storedInvitationData && window.storedInvitationData.success && window.storedInvitationData.data) {
        parsedLocalData = window.storedInvitationData.data;
    } 
    // Otherwise try formDataStorage
    else if (window.formDataStorage && typeof window.formDataStorage.getStoredData === 'function') {
        parsedLocalData = window.formDataStorage.getStoredData() || {};
    }
    // Fallback: collect from forms
    else {
        const allInputs = document.querySelectorAll('[data-theme-key]');
        allInputs.forEach(input => {
            const key = input.getAttribute('data-theme-key');
            if (key && input.value) {
                parsedLocalData[key] = input.value;
            }
        });
    }
    
    // Get all the elements with attribute 'data-key-uid'
    try {
        // console.log('Updating iframe data with metadata...');
        const themeIframe = document.getElementById('theme-iframe');
        if (!themeIframe) {
            if (retryCount < MAX_IFRAME_RETRIES) {
                setTimeout(() => logMetadata(retryCount + 1), IFRAME_RETRY_DELAY_MS);
                return;
            }
            console.warn('Iframe not found for metadata update after retries');
        }

        const iframeDoc = themeIframe?.contentDocument || themeIframe?.contentWindow?.document || null;
        const iframeIsReady = Boolean(
            iframeDoc &&
            (iframeDoc.readyState === 'interactive' || iframeDoc.readyState === 'complete')
        );

        const iframeElementsWithUid = iframeIsReady
            ? Array.from(iframeDoc.querySelectorAll('[data-key-uid]'))
            : [];
        const outsideElementsWithUid = Array.from(document.querySelectorAll('[data-key-uid]'));

        // Wait until iframe is ready and has the expected UID elements
        if ((!iframeIsReady || iframeElementsWithUid.length === 0) && retryCount < MAX_IFRAME_RETRIES) {
            setTimeout(() => logMetadata(retryCount + 1), IFRAME_RETRY_DELAY_MS);
            return;
        }

        // console.log(iframeDoc);

        // Get all elements with data-key-uid in the iframe and outside the iframe
        const elementsWithUid = iframeElementsWithUid.concat(outsideElementsWithUid);

        // console.log('Elements with data-key-uid found:', elementsWithUid.length);

        // console.log('Parsed Local Data:', parsedLocalData);
        let theme_data_fields = window.themeDataFields;
        // console.log('Theme Data Fields Raw:', theme_data_fields);
        
        if (theme_data_fields) {
            try {
                if (Array.isArray(theme_data_fields)) {
                    // console.log('Theme Data Fields:', theme_data_fields);
                    
                    // Check if key field with value 'your_name' exists in any object
                    const hasYourNameField = theme_data_fields.some(field => field.field === 'your_name');
                    const hasPartnerNameField = theme_data_fields.some(field => field.field === 'partner_name');
                    if (!hasYourNameField) {
                        // console.log(`Your Name is not allowed`);
                        const yourNameElement = document.getElementById('yourNameFieldBox');
                        if (yourNameElement) {
                            yourNameElement.remove();
                        }
                    }
                    if (!hasPartnerNameField) {
                        // console.log(`Partner Name is not allowed`);
                        const partnerNameElement = document.getElementById('partnerNameFieldBox');
                        if (partnerNameElement) {
                            partnerNameElement.remove();
                        }
                    }
                    // If the field exists, populate it with localStorage data if available
                    if (parsedLocalData) {
                        // console.log('Populating metadata fields with local data...');
                        // console.log('Theme Data Fields:', theme_data_fields);
                        // console.log("Theme Data Keys:", elementsWithUid);
                        elementsWithUid.forEach(element => {
                            // data-key-uid can be either the UID ('3dd32db5') or the field name ('your_name')
                            const uid = element.getAttribute('data-key-uid');
                            // Match by UID first, then fall back to matching by field name
                            const fieldMeta = theme_data_fields.find(field => field.uid === uid) ||
                                              theme_data_fields.find(field => field.field === uid);
                            const dataField = fieldMeta?.field;
                            const dataFormat = fieldMeta?.format;
                            const dataType = fieldMeta?.type;
                            let fieldValue = null;
                            let fileValue = null;
                            // console.log('Data Field:', dataField, 'Data Format:', dataFormat, 'Data Type:', dataType);
                            if (dataField && dataFormat) {
                                // console.log(`Processing field: ${dataField}, format: ${dataFormat}, type: ${dataType}`);
                                if (['month', 'day', 'date', 'year'].includes(dataField)) {
                                    fieldValue = parsedLocalData['event_date'] || null;
                                } else {
                                    fieldValue = parsedLocalData[dataField] || null;
                                    if (!fieldValue) {
                                        fieldValue = fieldMeta?.default_value || null;
                                    }
                                }
                            } else {
                                // console.log(`Processing UID: ${uid}, format: ${dataFormat}, type: ${dataType}`);
                                fieldValue = parsedLocalData[uid];
                                // console.log('Initial Field Value:', fieldValue);
                                if (!fieldValue && dataType === 'media') {
                                    fileValue = parsedLocalData['files'] ? parsedLocalData['files'][uid] : fieldMeta?.default_value || null;
                                    fieldValue = fileValue || null;
                                    // console.log('Media File Value:', fieldValue);
                                }
                            }
                            // console.log('Field Value:', fieldValue);
                            if (fieldValue && dataType == 'text') {
                                if (dataField === 'address') {
                                    const venueName = parsedLocalData['venue_name'] || null;
                                    const venueAddress = parsedLocalData['venue_address'] || null;
                                    if (venueName && venueAddress) {
                                        element.innerHTML = `${venueName}, ${venueAddress}`;
                                    } else if (venueName) {
                                        element.innerHTML = venueName;
                                    } else if (venueAddress) {
                                        element.innerHTML = venueAddress;
                                    } else {
                                        element.innerHTML = textFormatter(fieldValue, dataFormat) || fieldValue;
                                    }
                                } else {
                                    // console.log(`Processing text field: ${dataField}, format: ${dataFormat}, type: ${dataType}`);
                                    element.innerHTML = textFormatter(fieldValue, dataFormat) || fieldValue;
                                }
                            } else if (fieldValue && ['date', 'day', 'month', 'year'].includes(dataType)) {
                                // e.g. fieldValue = "2024-08-15"
                                // Check if the filedValue is a valid date string and the date is not in the past
                                const today = new Date();
                                const inputDate = new Date(fieldValue);
                                if (isNaN(inputDate) || inputDate < today) {
                                    // If invalid date or past date, use today's date
                                    fieldValue = today.toISOString().split('T')[0];
                                } 
                                // console.log('Updating date field:', fieldValue, dataFormat, dataType);
                                element.innerHTML = dateFormatter(fieldValue, dataFormat, dataType) || fieldValue;
                            } else if (fieldValue && dataType == 'time') {
                                element.innerHTML = timeFormatter(fieldValue, dataFormat) || fieldValue;
                            } else if (dataType === 'media' || ['image', 'video'].includes(dataType)) {
                                // Handle media fields - update src attribute instead of innerHTML
                                // console.log('Updating media field:', fieldValue, dataFormat, dataType);
                                if (fieldValue) {
                                    // Check if element is img or video tag
                                    const tagName = element.tagName.toLowerCase();
                                    if (['img', 'video'].includes(tagName)) {
                                        element.src = fieldValue;
                                    }
                                }
                            } else {
                                // Fall back to the default_value from the already-resolved fieldMeta
                                if (fieldMeta && fieldMeta.default_value) {
                                    element.innerHTML = fieldMeta.default_value;
                                } else {
                                    element.innerHTML = '';
                                }
                            }
                        });
                    }
                }
            } catch (e) {
                console.error('Invalid JSON in #theme_data_fields:', e);
            }
        } else {
            // console.log('Data Fields metadata not found');
        }
    } catch (error) {
        console.error('Error updating iframe data:', error);
    }
}

// Expose logMetadata function globally
window.logMetadata = logMetadata;

// Check if we're in update mode
const bodyElement = document.querySelector('body');
const currentPage = bodyElement ? bodyElement.getAttribute('data-cp') : null;
const isUpdateMode = currentPage === 'update' || window.location.pathname.includes('/update/');

// Always call logMetadata on page load.
// In create mode: populates data-key-uid elements from form/localStorage.
// In update mode: server-rendering fills UID-based placeholders via replace_template_placeholders,
//   but field-name-based data-key-uid elements (e.g. data-key-uid="your_name") are NOT filled
//   server-side, so we must run logMetadata here to populate them from storedInvitationData too.
if (isUpdateMode) {
    const themeIframe = document.getElementById('theme-iframe');
    if (themeIframe) {
        themeIframe.addEventListener('load', () => {
            setTimeout(() => logMetadata(), 150);
        });
    }
    // Fallback: also run after a short delay in case iframe already loaded
    setTimeout(() => logMetadata(), 500);
} else {
    logMetadata();
}

function textFormatter(value, format) {
    if (!value) return '';
    if (!format || format === 'default') return value;
    switch (format) {
        case 'initial':
            return value.trim().charAt(0).toUpperCase();
        case 'uppercase':
            return value.toUpperCase();
        case 'lowercase':
            return value.toLowerCase();
        case 'capitalize':
            return value.trim().charAt(0).toUpperCase() + value.trim().slice(1).toLowerCase();
        default:
            return value;
    }
}

function dateFormatter(value, format, type) {
    if (!value) return '';
    // Accepts value as string or date
    let dateObj;
    // Always expect ISO date string for value, e.g. "2024-01-15"
    if (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}$/)) {
        dateObj = new Date(value + 'T00:00:00');
    } else if (!isNaN(value)) {
        // If value is just a number, build a date
        if (type === 'year') {
            dateObj = new Date(value, 0, 1);
            // console.log('Year dateObj:', dateObj);
        } else if (type === 'month') {
            dateObj = new Date(2000, value - 1, 1);
            // console.log('Month dateObj:', dateObj);
        } else if (type === 'day' || type === 'date') {
            dateObj = new Date(2000, 0, value);
            // console.log('Day/Date dateObj:', dateObj);
        }
    } else {
        dateObj = new Date(value);
    }

    // Date
    if (type === 'date') {
        if (!dateObj || isNaN(dateObj)) return value;
        const day = dateObj.getDate();
        switch (format) {
            case 'numeric':
                return `${day}`;
            case 'two_digit':
                return day < 10 ? `0${day}` : `${day}`;
            case 'ordinal':
                return day + ordinalSuffix(day);
            case 'ordinal_written':
                return writtenOrdinal(day);
            case 'roman':
                return toRoman(day);
            default:
                return `${day}`;
        }
    }
    // Day
    if (type === 'day') {
        if (!dateObj || isNaN(dateObj)) return value;
        // For ISO date string, get weekday
        let dayStr = dateObj.toLocaleDateString('en-US', { weekday: 'long' });
        switch (format) {
            case 'full':
                return dayStr;
            case 'short':
                return dateObj.toLocaleDateString('en-US', { weekday: 'short' });
            case 'initial':
                return dayStr.charAt(0);
            case 'uppercase_full':
                return dayStr.toUpperCase();
            case 'uppercase_short':
                return dateObj.toLocaleDateString('en-US', { weekday: 'short' }).toUpperCase();
            default:
                return dayStr;
        }
    }
    // Month
    if (type === 'month') {
        if (!dateObj || isNaN(dateObj)) return value;
        let monthStr = dateObj.toLocaleDateString('en-US', { month: 'long' });
        switch (format) {
            case 'numeric':
                return `${dateObj.getMonth() + 1}`;
            case 'two_digit':
                return dateObj.getMonth() + 1 < 10 ? `0${dateObj.getMonth() + 1}` : `${dateObj.getMonth() + 1}`;
            case 'short':
                return dateObj.toLocaleDateString('en-US', { month: 'short' });
            case 'long':
                return monthStr;
            case 'uppercase_short':
                return dateObj.toLocaleDateString('en-US', { month: 'short' }).toUpperCase();
            case 'uppercase_long':
                return monthStr.toUpperCase();
            case 'roman':
                return toRoman(dateObj.getMonth() + 1);
            default:
                return monthStr;
        }
    }
    // Year
    if (type === 'year') {
        if (!dateObj || isNaN(dateObj)) return value;
        const year = dateObj.getFullYear();
        switch (format) {
            case 'full':
                return `${year}`;
            case 'two_digit':
                return `${year}`.slice(-2);
            case 'roman':
                return toRoman(year);
            default:
                return `${year}`;
        }
    }
    return value;
    function ordinalSuffix(n) {
        const s = ["th", "st", "nd", "rd"], v = n % 100;
        return s[(v - 20) % 10] || s[v] || s[0];
    }
    function writtenOrdinal(n) {
        const ordinals = ["First", "Second", "Third", "Fourth", "Fifth", "Sixth", "Seventh", "Eighth", "Ninth", "Tenth", "Eleventh", "Twelfth", "Thirteenth", "Fourteenth", "Fifteenth", "Sixteenth", "Seventeenth", "Eighteenth", "Nineteenth", "Twentieth", "Twenty-first", "Twenty-second", "Twenty-third", "Twenty-fourth", "Twenty-fifth", "Twenty-sixth", "Twenty-seventh", "Twenty-eighth", "Twenty-ninth", "Thirtieth", "Thirty-first"];
        return ordinals[n - 1] || n;
    }
    function toRoman(num) {
        if (typeof num !== 'number') num = parseInt(num);
        if (isNaN(num)) return num;
        const lookup = {M:1000,CM:900,D:500,CD:400,C:100,XC:90,L:50,XL:40,X:10,IX:9,V:5,IV:4,I:1}, roman = [];
        for (let i in lookup) {
            while (num >= lookup[i]) {
                roman.push(i);
                num -= lookup[i];
            }
        }
        return roman.join('');
    }
    return value;
}

function timeFormatter(value, format) {
    if (!value) return '';
    if (!format || format === 'default') return value;
    // Accepts value as "6 PM", "14:30", "2:30 PM", "14"
    let hour = 0, minute = 0;
    let valueStr = value.toString().trim();
    // Try to parse "6 PM", "2:30 PM", "14:30", "14"
    let match = valueStr.match(/^(\d{1,2})(?::(\d{2}))?\s*(AM|PM)?$/i);
    if (match) {
        hour = parseInt(match[1]);
        minute = match[2] ? parseInt(match[2]) : 0;
        if (match[3]) {
            if (match[3].toUpperCase() === 'PM' && hour < 12) hour += 12;
            if (match[3].toUpperCase() === 'AM' && hour === 12) hour = 0;
        }
    } else {
        // fallback: try Date parsing
        let dateObj = new Date(`1970-01-01T${valueStr}:00`);
        if (!isNaN(dateObj)) {
            hour = dateObj.getHours();
            minute = dateObj.getMinutes();
        }
    }
    switch (format) {
        case '12_hour':
            return to12Hour(hour, minute, true);
        case '12_hour_no_minutes':
            return to12Hour(hour, minute, false);
        case '24_hour':
            return to24Hour(hour, minute, true);
        case '24_hour_no_minutes':
            return to24Hour(hour, minute, false);
        case 'written':
            return writtenTime(hour, minute);
        case 'casual':
            return casualTime(hour, minute);
        default:
            return to12Hour(hour, minute, true);
    }
    // Helper functions
    function to12Hour(h, m, showMinutes) {
        let hour = h % 12 || 12;
        let suffix = h < 12 ? 'AM' : 'PM';
        if (showMinutes && m > 0) {
            return `${hour}:${m.toString().padStart(2, '0')} ${suffix}`;
        } else {
            return `${hour} ${suffix}`;
        }
    }
    function to24Hour(h, m, showMinutes) {
        if (showMinutes && m > 0) {
            return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
        } else {
            return `${h}`;
        }
    }
    function writtenTime(h, m) {
        // Example: "Two thirty in the afternoon"
        const hoursWritten = ["Twelve", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve"];
        let hourWord = hoursWritten[h % 12];
        let minuteWord = m === 0 ? '' : (m < 10 ? `oh ${m}` : `${m}`);
        let period = h < 12 ? 'in the morning' : (h < 18 ? 'in the afternoon' : 'in the evening');
        return `${hourWord}${minuteWord ? ' ' + minuteWord : ''} ${period}`;
    }
    function casualTime(h, m) {
        // Example: "Half past two"
        let hourWord = ["Twelve", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve"][h % 12];
        if (m === 0) return `${hourWord} o'clock`;
        if (m === 30) return `Half past ${hourWord}`;
        if (m === 15) return `Quarter past ${hourWord}`;
        if (m === 45) return `Quarter to ${["Twelve", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve"][(h + 1) % 12]}`;
        return `${m} past ${hourWord}`;
    }
}